import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { SessionService } from '../session/session.service';

export const authGuard: CanActivateFn = (): boolean | UrlTree => {
  const sessionService = inject(SessionService);
  const router = inject(Router);

  if (sessionService.user() === undefined) {
    return router.createUrlTree(['/login']);
  }

  return true;
}; 